const Servicio = ({ icono, titulo, descripcion }) => {
  return (
    <div className="relative group h-full">
      <div className="bg-gradient-to-br from-zinc-900 to-zinc-800 rounded-lg overflow-visible border border-gray-700 hover:border-gray-500 transition-all duration-300 p-4 md:p-6 h-full flex flex-col items-center justify-center shadow-lg hover:shadow-xl hover:shadow-gray-500/20 group-hover:h-[105%] group-hover:py-6">
        {/* Contenedor del ícono y título que sube en hover */}
        <div className="flex flex-col items-center transition-transform duration-500 group-hover:-translate-y-4">
          {/* Icono con fondo circular de color */}
          <div className="mb-6 p-2 bg-gray-500/10 rounded-full border border-gray-500/30 group-hover:bg-gray-500/20 group-hover:border-gray-500 transition-all duration-300 text-white">
            <div className="w-16 h-16 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
              {icono}
            </div>
          </div>

          {/* Título siempre visible */}
          <h3 className="text-lg  text-white text-center mb-3 font-messina tracking-wider">{titulo}</h3>
        </div>

        {/* Descripción que aparece en hover */}
        <p className="font-light text-gray-300 text-center opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-40 transition-all duration-500 font-kanit leading-relaxed overflow-hidden">
          {descripcion}
        </p>

        {/* Efecto de línea decorativa en hover */}
        <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>
    </div>
  )
}

export default Servicio
